import React, { PureComponent } from 'react';
import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Pagination from '../pagination';
import { SaleAction } from '../../store/actions';

class List extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    deleteSale: PropTypes.func,
    getSales: PropTypes.func,
    location: PropTypes.object,
    markPaidSale: PropTypes.func,
    permissions: PropTypes.arrayOf(PropTypes.string),
    sales: PropTypes.object,
  };

  componentDidMount() {
    this.props.getSales(
      Object.fromEntries(new URLSearchParams(this.props.location.search)),
    );
  }

  onDelete(row) {
    if (!confirm('Are you sure?')) {
      return;
    }
    this.props.deleteSale(row.id);
  }

  onMarkPaid(row) {
    this.props.markPaidSale(row.id);
  }

  onSearch(event) {
    const {
      target: { value },
    } = event;
    this.props.getSales({ query: value });
  }

  render() {
    const {
      authHasOffice = false,
      getSales = () => {},
      location = {},
      permissions = [],
      sales: { data: sales = [], links = [] } = {},
    } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Sale</h3>
              <div className="card-tools d-print-none">
                <Pagination
                  getList={getSales}
                  links={links}
                  location={location}
                />
              </div>
              <div className="card-tools d-print-none mr-2">
                <div
                  className="input-group input-group-sm"
                  style={{ width: '150px' }}
                >
                  <input
                    className="form-control"
                    onChange={this.onSearch.bind(this)}
                    placeholder="Search"
                    type="text"
                  />
                </div>
              </div>
              {permissions?.includes?.('sale.create') && (
                <div className="card-tools d-print-none mr-2">
                  <div className="input-group input-group-sm">
                    <Link
                      className="btn btn-primary btn-sm"
                      to={`${this.props.match?.path}/create`}
                    >
                      <i className="fas fa-plus-square mr-1"></i>
                      Create
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <div className="card-body p-0 table-responsive">
              {sales?.length === 0 && (
                <p className="text-center my-2">No data found.</p>
              )}
              {sales?.length > 0 && (
                <table className="table table-striped text-nowrap">
                  <thead>
                    <tr>
                      {permissions?.some?.(p =>
                        [
                          'sale.angikar_nama',
                          'sale.cash_memo',
                          'sale.certificate',
                          'sale.delete',
                          'sale.edit',
                          'sale.invoice',
                          'sale.mark_paid',
                          'sale.receive',
                          'sale.registration_application',
                          'sale.transaction',
                          'sale.view',
                        ]?.includes?.(p),
                      ) && (
                        <th
                          className="d-print-none"
                          style={{ minWidth: '225px' }}
                        >
                          Action
                        </th>
                      )}
                      {!authHasOffice && <th>Office</th>}
                      <th>ID</th>
                      <th>Sold At</th>
                      <th>Customer Name</th>
                      <th>Customer Mobile</th>
                      <th>Chalan Number</th>
                      <th>Model</th>
                      <th>Chassis Number</th>
                      <th>Engine Number</th>
                      <th>Color</th>
                      <th>Price</th>
                      <th>Discount</th>
                      <th>Total</th>
                      <th>Advance</th>
                      <th>Initial Due</th>
                      <th>Total Received</th>
                      <th>Due Till Now</th>
                      <th>Installments</th>
                      <th>Interest Rate</th>
                      <th>Monthly Interest</th>
                      <th>Total Interest</th>
                      <th>Monthly Installment</th>
                      <th>Paid/Due</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sales?.map?.(row => (
                      <tr
                        className={ClassNames({ 'bg-warning': !!row.is_due })}
                        key={row.id}
                      >
                        {permissions?.some?.(p =>
                          [
                            'sale.angikar_nama',
                            'sale.cash_memo',
                            'sale.certificate',
                            'sale.delete',
                            'sale.edit',
                            'sale.invoice',
                            'sale.mark_paid',
                            'sale.receive',
                            'sale.registration_application',
                            'sale.transaction',
                            'sale.view',
                          ]?.includes?.(p),
                        ) && (
                          <td className="d-print-none">
                            <div className="btn-group">
                              {permissions?.includes?.('sale.view') && (
                                <Link
                                  className="align-items-center btn btn-primary btn-sm d-inline-flex"
                                  to={`${this.props.match?.path}/${row.id}/detail`}
                                >
                                  <i className="fas fa-info mr-1"></i>
                                  Detail
                                </Link>
                              )}
                              {permissions?.includes?.('sale.edit') && (
                                <Link
                                  className="align-items-center btn btn-info btn-sm d-inline-flex"
                                  to={`${this.props.match?.path}/${row.id}/edit`}
                                >
                                  <i className="fas fa-edit mr-1"></i>
                                  Edit
                                </Link>
                              )}
                              {permissions?.includes?.('sale.delete') && (
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => this.onDelete(row)}
                                  type="button"
                                >
                                  <i className="fas fa-trash mr-1"></i>
                                  Delete
                                </button>
                              )}
                              {(permissions?.some?.(p =>
                                [
                                  'sale.angikar_nama',
                                  'sale.cash_memo',
                                  'sale.certificate',
                                  'sale.invoice',
                                  'sale.registration_application',
                                  'sale.transaction',
                                ]?.includes?.(p),
                              ) ||
                                (permissions?.some?.(p =>
                                  [
                                    'sale.mark_paid',
                                    'sale.receive',
                                  ]?.includes?.(p),
                                ) &&
                                  !!row.is_due)) && (
                                <>
                                  <button
                                    className="btn btn-sm btn-success dropdown-toggle"
                                    data-boundary="window"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                    type="button"
                                  />
                                  <div className="dropdown-menu" role="menu">
                                    {permissions?.includes?.(
                                      'sale.angikar_nama',
                                    ) && (
                                      <Link
                                        className="dropdown-item"
                                        to={`${this.props.match?.path}/${row.id}/angikar-nama`}
                                      >
                                        <i className="fas fa-receipt mr-1"></i>
                                        Angikar Nama
                                      </Link>
                                    )}
                                    {permissions?.includes?.(
                                      'sale.cash_memo',
                                    ) && (
                                      <Link
                                        className="dropdown-item"
                                        to={`${this.props.match?.path}/${row.id}/cash-memo`}
                                      >
                                        <i className="fas fa-receipt mr-1"></i>
                                        Cash Memo
                                      </Link>
                                    )}
                                    {permissions?.includes?.(
                                      'sale.certificate',
                                    ) && (
                                      <Link
                                        className="dropdown-item"
                                        to={`${this.props.match?.path}/${row.id}/certificate`}
                                      >
                                        <i className="fas fa-receipt mr-1"></i>
                                        Certificate
                                      </Link>
                                    )}
                                    {permissions?.includes?.(
                                      'sale.invoice',
                                    ) && (
                                      <Link
                                        className="dropdown-item"
                                        to={`${this.props.match?.path}/${row.id}/invoice`}
                                      >
                                        <i className="fas fa-receipt mr-1"></i>
                                        Invoice
                                      </Link>
                                    )}
                                    {permissions?.includes?.(
                                      'sale.registration_application',
                                    ) && (
                                      <Link
                                        className="dropdown-item"
                                        to={`${this.props.match?.path}/${row.id}/registration-application`}
                                      >
                                        <i className="fas fa-receipt mr-1"></i>
                                        Registration Application
                                      </Link>
                                    )}
                                    {permissions?.includes?.(
                                      'sale.transaction',
                                    ) && (
                                      <Link
                                        className="dropdown-item"
                                        to={`${this.props.match?.path}/${row.id}/transaction`}
                                      >
                                        <i className="fas fa-money-bill-wave mr-1"></i>
                                        Transaction
                                      </Link>
                                    )}
                                    {permissions?.includes?.('sale.receive') &&
                                      !!row.is_due && (
                                        <Link
                                          className="bg-warning dropdown-item"
                                          to={`${this.props.match?.path}/${row.id}/receive`}
                                        >
                                          <i className="fas fa-money-bill mr-1"></i>
                                          Receive
                                        </Link>
                                      )}
                                    {permissions?.includes?.(
                                      'sale.mark_paid',
                                    ) &&
                                      !!row.is_due && (
                                        <button
                                          className="bg-warning dropdown-item"
                                          onClick={() =>
                                            confirm('Are you sure?') &&
                                            this.onMarkPaid(row)
                                          }
                                          type="button"
                                        >
                                          <i className="fas fa-check-square mr-1"></i>
                                          Mark Paid
                                        </button>
                                      )}
                                  </div>
                                </>
                              )}
                            </div>
                          </td>
                        )}
                        {!authHasOffice && <td>{row.office?.name}</td>}
                        <td>{row.id}</td>
                        <td>{row.sold_at}</td>
                        <td>{row.customer?.name}</td>
                        <td>{row.customer?.mobile_number}</td>
                        <td>{row.purchase?.chalan_number}</td>
                        <td>{row.purchase?.vehicle?.model}</td>
                        <td>{row.purchase?.chassis_number}</td>
                        <td>{row.purchase?.engine_number}</td>
                        <td>{row.purchase?.color?.name}</td>
                        <td>{row.price}</td>
                        <td>{row.discount}</td>
                        <td>{row.total}</td>
                        <td>{row.advance}</td>
                        <td>{row.initial_due}</td>
                        <td>{row.total_received}</td>
                        {!!row.is_due ? (
                          <>
                            <td>{row.due_till_now}</td>
                            <td>{row.installments}</td>
                            <td>{row.interest_rate}</td>
                            <td>{row.monthly_interest}</td>
                            <td>{row.total_interest}</td>
                            <td>{row.monthly_installment}</td>
                          </>
                        ) : (
                          <td colSpan="6"></td>
                        )}
                        <td>{!!row.is_due ? 'Due' : 'Paid'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authHasOffice: !!state?.auth?.office,
  permissions: state?.auth?.permissions,
  sales: state?.sale?.list,
});

const mapDispatchToProps = dispatch => ({
  deleteSale: id => dispatch(SaleAction.deleteSale(id)),
  getSales: params => dispatch(SaleAction.getSales(params)),
  markPaidSale: id => dispatch(SaleAction.markPaidSale(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(List);
